import { v4 as uuidv4 } from 'uuid';
import { OAuthSessionStates } from './sessionActions';
import { clearAuthSession } from './api';

function stateRedirect({ state, authSession, params }) {
    if (state === OAuthSessionStates.NO_TOKEN_AVAILABLE) {
        // EcalWorld is publicly browsable — anonymous users stay on the page.
        // persistOauthInfo so type (google/outlook) is remembered for the dialog.
        this.persistOauthInfo({ session: authSession, params });
        this.initLogin();
    } else if (state === OAuthSessionStates.FROM_CALENDAR_WITH_NO_TOKEN) {
        this.persistOauthInfo({ session: authSession, params });
        this.initLogin();
    } else if (state === OAuthSessionStates.TOKEN_EXPIRED) {
        // Clear all session data — UI will drop to anonymous state via sessionExpired signal
        clearAuthSession();
        this.session = null;
        this.observed.sessionExpired = uuidv4();
        this.initLogin();
    } else if (state === OAuthSessionStates.OAUTH_SESSION_SUCCESS) {
        this.finalizeSessionInit({ authSession, params });
    }
}

export default stateRedirect;
